function convertSecondToYear(num) {
  let eq =
    "Converting " +
    num +
    " second to year: \n" +
    num +
    " * 3.1688738506811e-8 = ";
  let rep = num * 3.1688738506811e-8;
  return eq + rep.toFixed(8);
}

function convertSecondToWeek(num) {
  let eq =
    "Converting " +
    num +
    " second to week: \n" +
    num +
    " * 0.0000016534391534391535 = ";
  let rep = num * 0.0000016534391534391535;
  return eq + rep.toFixed(7);
}

function convertSecondToMonth(num) {
  let eq =
    "Converting " +
    num +
    " second to month: \n" +
    num +
    " * 3.802648620817372e-7 = ";
  let rep = num * 3.802648620817372e-7;
  return eq + rep.toFixed(7);
}

function convertSecondToMinute(num) {
  let eq =
    "Converting " +
    num +
    " second to minute: \n" +
    num + " * 0.016666666666666666 = ";
  let rep = num * 0.016666666666666666;
  return eq + rep.toFixed(4);
}

function convertSecondToHour(num) {
  let eq =
    "Converting " + num + " second to hour: \n" + num +
    " * 0.0002777777777777778 = ";
  let rep = num * 0.0002777777777777778;
  return eq + rep.toFixed(6);
}

function convertSecondToDay(num) {
  let eq =
    "Converting " +
    num +
    " second to day: \n" +
    num +
    " * 0.000011574074074074073 = ";
  let rep = num * 0.000011574074074074073;
  return eq + rep.toFixed(6);
}

export {
  convertSecondToDay,
  convertSecondToHour,
  convertSecondToMinute,
  convertSecondToMonth,
  convertSecondToWeek,
  convertSecondToYear
};
